<template>
  <div>
    <b-modal v-model="showModal"
      title="Detalle del avance"
      header-bg-variant="secondary"
      header-text-variant="white"
      scrollable
      @close="close"
      @show="getRecord"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      size="xl">
      <b-overlay :show="loading" rounded="sm">
        <div v-if="record">
          <div class="row mb-2">
            <div class="col-md-6"><b>Alumno:</b> {{ record.student }}</div>
            <div class="col-md-6"><b>Curso:</b> {{ record.course }}</div>
            <div class="col-md-6"><b>Vigencia:</b> {{ record.startDate }} – {{ record.endDate }}</div>
            <div class="col-md-6">
              <b>Estado:</b>
              <span :class="record.daysLeft !== null && record.daysLeft < 0 ? 'text-danger' : ''">
                {{ vigencyLabel(record.daysLeft) }}
              </span>
            </div>
          </div>

          <div class="panel-title">Avance por módulo</div>
          <div class="table-responsive tableBg mb-2">
            <table class="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Módulo</th>
                  <th>Estado</th>
                  <th>Lectura</th>
                  <th>Práctica</th>
                  <th>Puntaje</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(m, i) in record.modules" :key="i">
                  <td>{{ m.module }}</td>
                  <td>
                    <span class="badge" :class="statusClass(m.status)">{{ m.statusLabel }}</span>
                  </td>
                  <td>
                    <div class="progress-mini"><div class="progress-mini-bar" :style="{ width: m.readPercent + '%' }"></div></div>
                    <small>{{ m.readPercent }}% &middot; {{ m.readDone }} de {{ m.readRequired }}</small>
                  </td>
                  <td>
                    <div class="progress-mini"><div class="progress-mini-bar" :style="{ width: m.practicePercent + '%' }"></div></div>
                    <small>{{ m.practicePercent }}% &middot; {{ m.practiceDone }} de {{ m.practiceRequired }}</small>
                  </td>
                  <td>{{ m.score }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="panel-title">Evaluaciones rendidas</div>
          <div v-if="record.tests && record.tests.length" class="table-responsive tableBg">
            <table class="table table-striped table-bordered">
              <thead>
                <tr><th>Fecha</th><th>Módulo</th><th>Puntaje</th><th>Tiempo</th></tr>
              </thead>
              <tbody>
                <tr v-for="(t, i) in record.tests" :key="i">
                  <td>{{ t.date }}</td>
                  <td>{{ t.module }}</td>
                  <td>{{ t.score }}</td>
                  <td>{{ t.time }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p v-else class="text-muted">Este alumno todavía no ha rendido ninguna evaluación.</p>
        </div>

        <div class="modal-footer">
          <button class="btn btn-sm btn-danger" type="button" @click="close"> <i class="fas fa-times fa-fw"></i>Cerrar</button>
        </div>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { BModal, BOverlay } from 'bootstrap-vue';

export default {
  components: { BModal, BOverlay },
  props: ['id', 'showModal'],
  data() {
    return {
      record: null,
      loading: false,
    }
  },
  methods: {
    vigencyLabel(days) {
      if (days === null) return 'Sin fecha'
      if (days < 0) return 'Vencido hace ' + Math.abs(days) + ' días'
      if (days === 0) return 'Vence hoy'
      return 'Quedan ' + days + ' días'
    },
    statusClass(status) {
      const classes = { 0: 'badge-secondary', 1: 'badge-warning', 2: 'badge-success' }
      return classes[status] !== undefined ? classes[status] : 'badge-secondary'
    },
    close() {
      this.$emit('update:showModal', false)
    },
    getRecord() {
      if (!this.id) return
      this.loading = true
      this.record = null
      axios.get(`/studentProgress/${this.id}`)
        .then(response => {
          this.record = response.data.data
        })
        .catch(error => { console.error(error) })
        .finally(() => { this.loading = false })
    },
  }
}
</script>
